import { DropDownOption } from '../drop-down';

export const getOptionValue = (option: DropDownOption): string | undefined =>
  option.value ?? option.key;

export const isEmptyValue = (value: string | undefined): boolean =>
  !value || value === '';

export const getOptionLabel = (option: DropDownOption): string =>
  option.label?.toString() ||
  option.value?.toString() ||
  option.key?.toString() ||
  '';
